var exports = {
  "Nr": "PricingCard.module__card___UGgzdm",
  "OW": "PricingCard.module__cardDefault___UGgzdm" + " " + "PricingCard.module__card___UGgzdm",
  "WI": "PricingCard.module__cardPopular___UGgzdm" + " " + "PricingCard.module__card___UGgzdm",
  "uX": "PricingCard.module__badgeSpace___UGgzdm",
  "qS": "PricingCard.module__badge___UGgzdm",
  "Ys": "PricingCard.module__badgeOnBrand___UGgzdm",
  "HH": "PricingCard.module__badgePlaceholder___UGgzdm",
  "zH": "PricingCard.module__popularBadge___UGgzdm",
  "B_": "PricingCard.module__popularBadgeSpace___UGgzdm",
  "r9": "PricingCard.module__disabled___UGgzdm",
  "L5": "PricingCard.module__selectButton___UGgzdm",
  "_C": "PricingCard.module__soldOutBadge___UGgzdm",
  "hQ": "PricingCard.module__contentContainer___UGgzdm",
  "JJ": "PricingCard.module__cardTitle___UGgzdm",
  "UZ": "PricingCard.module__cardTitleDefault___UGgzdm" + " " + "PricingCard.module__cardTitle___UGgzdm",
  "_": "PricingCard.module__cardTitlePopular___UGgzdm" + " " + "PricingCard.module__cardTitle___UGgzdm",
  "CA": "PricingCard.module__cardPrice___UGgzdm",
  "$V": "PricingCard.module__cardPriceDefault___UGgzdm" + " " + "PricingCard.module__cardPrice___UGgzdm",
  "pW": "PricingCard.module__cardPricePopular___UGgzdm" + " " + "PricingCard.module__cardPrice___UGgzdm",
  "ce": "PricingCard.module__cardPeriod___UGgzdm",
  "Lo": "PricingCard.module__cardPeriodDefault___UGgzdm" + " " + "PricingCard.module__cardPeriod___UGgzdm",
  "xP": "PricingCard.module__cardPeriodPopular___UGgzdm" + " " + "PricingCard.module__cardPeriod___UGgzdm",
};

module.exports = exports;
